import { parseSearchWith, stringifySearchWith } from '@tanstack/react-router';
import { encodeCsv } from './csv.js';

/**
 * TanStack solo llama al stringifier con objetos y arrays: los primitivos ya salen
 * como texto. Aquí solo hay que decidir cómo se ve una lista en la URL.
 */
export const toParamValue = (value: object): string =>
  Array.isArray(value) ? encodeCsv(value.map(String)) : JSON.stringify(value);

/**
 * Serializador propio en vez del JSON por defecto de TanStack (diseño §11): con JSON,
 * `?state=["a","b"]` llega codificado e ilegible y no coincide con lo que acepta la API.
 * Sin `parser` en `stringifySearchWith`, las cadenas viajan sin comillas añadidas.
 */
export const stringifySearch = stringifySearchWith(toParamValue);

const parseRaw = parseSearchWith((value) => value);

const asText = (value: unknown): string | string[] =>
  Array.isArray(value) ? value.map(String) : String(value);

/**
 * El `decode` interno de TanStack ya convierte `?limit=50` en número y `?flag=true`
 * en booleano antes de que el parser vea nada, así que una búsqueda de texto "123"
 * llegaría como number y el schema la rechazaría. Se restituye el invariante:
 * de la URL todo sale como texto y lo tipa `validateSearch` con `csvList` o `z.coerce`.
 */
export const parseSearch = (searchStr: string): Record<string, string | string[]> => {
  const raw = parseRaw(searchStr) as Record<string, unknown>;
  const out: Record<string, string | string[]> = {};
  for (const key in raw) out[key] = asText(raw[key]);
  return out;
};
